/* AAT Price badge — berekent het kortingspercentage uit de prijzen
   en plaatst een badge in de prijsregel. */
(function () {
  function parsePrice(t) {
    t = t.replace(/[^\d.,]/g, '');
    if (t.indexOf(',') > -1 && t.indexOf('.') > -1) {
      t = t.replace(/\./g, '').replace(',', '.');
    } else {
      t = t.replace(',', '.');
    }
    return parseFloat(t);
  }
  function run() {
    var wrap = document.querySelector('.product__info-container .price--on-sale .price__sale');
    if (!wrap || wrap.querySelector('.aat-badge')) return;
    var sale = wrap.querySelector('.price-item--sale');
    var reg = wrap.querySelector('s.price-item--regular');
    if (!sale || !reg) return;
    var s = parsePrice(sale.textContent);
    var c = parsePrice(reg.textContent);
    if (!s || !c || c <= s) return;
    var p = Math.round((1 - s / c) * 100);
    var b = document.createElement('span');
    b.className = 'aat-badge';
    b.textContent = p + '% korting';
    wrap.appendChild(b);
  }
  if (document.readyState !== 'loading') run();
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('change', function () { setTimeout(run, 250); });
})();
